import Grid from '@material-ui/core/Grid';
import EngineerCard from 'components/Card/EngineerCard';
import ReadView from 'components/Crud/views/Read';
import { engineerDomain } from 'models';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEngineerData } from 'store/selectors';
import EngineerCalendar, {
  EngineerCalendarDatesProvider
} from './EngineerCalendar/EngineerCalendar';
import { adjustmentsSlice, patchesSlice } from './store';
import { useStyles } from './styles';

function EngineerView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { id: itemId } = useParams<{ id: string }>();
  const engineerData = useEngineerData(itemId);

  useEffect(() => {
    if (itemId) {
      dispatch(adjustmentsSlice.actions.get.list(itemId));
      if (patchesSlice.actions.changePagination) {
        dispatch(
          patchesSlice.actions.changePagination({
            pageIndex: 0,
            pageSize: 10000
          })
        );
      }
      dispatch(patchesSlice.actions.get.list());
    }
  }, []);

  return (
    <ReadView domain={engineerDomain}>
      {() =>
        engineerData === undefined ? null : (
          <>
            <div className={classes.engineerCardContainer}>
              <EngineerCard engineerId={itemId} />
            </div>
            <Grid
              item
              container
              spacing={4}
              justifyContent="center"
              className={classes.engineerContainer}
            >
              <EngineerCalendarDatesProvider>
                <EngineerCalendar />
              </EngineerCalendarDatesProvider>
            </Grid>
          </>
        )
      }
    </ReadView>
  );
}

export default EngineerView;
